<template>
  <div>
    <b-modal
      id="create-appointment"
      ref="modal"
      scrollable
      header-class="headerModal"
      centered
      size="xl"
      :title="$t('CreateAppointment')"

      title-class="red"
      modal-class="dd"
      hide-footer
      @hide="onCancel"
    >
      <b-form
        class="fixed-height-modal"
        @reset="onCancel"
      >
        <div
          class="existingClient"
          style="display:flex; flex-direction:row; width: 46%; justify-content: space-between;"
        >
          <b-button
            v-b-toggle.collapse-345
            class="m-1"
            variant="light"
          >
            <b-icon-arrows-expand />
          </b-button>
          <b-form-group
            style="width: 80%; padding-bottom: 10px;"
            :label="$t('SelectExistingClient')"
          >
            <div>
              <div class="black">
                <b-icon-search
                  v-if="searchClients == null"
                  class="search1"
                  style=" position: absolute; left: 5px; top: 10px"
                />
                <b-icon-x-circle
                  v-else-if="clientId != '00000000-0000-0000-0000-000000000000'"
                  class="search1"
                  style="position: absolute; margin-top: -6px; left: 200px; top: 17px; cursor: pointer"
                  @click="searchClients = null ,client= false, resetCustomerData()"
                />
                <input
                  v-model="searchClients"
                  autocomplete="off"
                  type="text"
                  name="search-box"
                  :placeholder="$t('ClientName')"
                  :style="getFirstNames.length > 0 && noSearch ? 'border-radius: 8px 8px 8px 8px' : 'border-radius: 8px 8px 8px 8px; padding-left: 25px;'"
                  @keyup="inputChanged"
                  @keydown.down="onArrowDown"
                  @keydown.up="onArrowUp"
                >
              </div>
              <div
                v-if="getFirstNames.length > 0 && noSearch"
                ref="scrollContainer"
                class="dropdrop"
                :style="getFirstNames.length > 7 ? 'height: 210px' : 'height: auto'"
              >
                <div
                  v-for="(result, index) in getFirstNames"
                  :key="index"
                  ref="options"
                  style="cursor: pointer"
                  class="search-item"
                  :class="{ 'is-active': index === arrowCounter }"
                  @click="searchByOn(result.clientId); noSearch = false"
                >
                  <p style="margin: 0">
                    {{ result.nameToDisplay }}
                  </p>
                </div>
              </div>
            </div>
          </b-form-group>
          <b-button
            v-if="client == false && clientId == '00000000-0000-0000-0000-000000000000'"
            type="button"
            variant="none"
            class="buttonSubmit"
            style="width: 290px; height: 40px; margin-top: 27px;"
            @click="addNewClient"
          >
            {{ $t(`Addclient`) }}
          </b-button>
        </div>

        <section
          v-if="client == true || clientId != '00000000-0000-0000-0000-000000000000'"
          class="custom-modal__wrapper"
          style="border-width: 3px"
        >
          <b-tabs>
            <b-tab
              :title="$t('PersonalInfo')"
              active
            >
              <template #title>
                <strong style="font-weight: 500; color: black">{{ $t("PersonalInfo") }}</strong>
              </template>
              <b-collapse
                id="collapse-345"
                visible
              >
                <div
                  class="hello"
                  style="padding-top: 20px"
                >
                  <b-form-group :label="$t('Salutation')">
                    <vue-select
                      v-model="$v.staticForm.ordererDto.salutation.$model"
                      :options="salutation"
                      required
                      :placeholder="$t('SelectSalutation')"
                      :state="validateState('salutation')"
                      aria-describedby="input-1-live-feedback"
                    />
                    <p
                      v-if="staticForm.ordererDto.salutation == null && isButtonSubmited == true"
                      style="color: red"
                    >
                      {{ $t('This_is_a_required_field') }}
                    </p>
                  </b-form-group>

                  <b-form-group :label="`${$t('FirstName')}`">
                    <b-form-input
                      v-model="$v.staticForm.ordererDto.firstName.$model"
                      :state="validateState('firstName')"
                      placeholder="e.g. Michael"
                      aria-describedby="input-1-live-feedback"
                    />
                    <b-form-invalid-feedback id="input-1-live-feedback">{{
                      $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                    }}</b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group :label="`${$t('LastName')}`">
                    <b-form-input
                      v-model="$v.staticForm.ordererDto.lastName.$model"
                      :state="validateState('lastName')"
                      placeholder="e.g. Goodman"
                      aria-describedby="input-1-live-feedback"
                    />
                    <b-form-invalid-feedback id="input-1-live-feedback">{{
                      $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </div>

                <div class="hello">

                  <b-form-group :label="`${$t('Gender')}`">
                    <vue-select
                      v-model="$v.staticForm.ordererDto.gender.$model"
                      :options="[$t('Male'), $t('Female')]"
                      :placeholder="$t('SelectGender')"
                      required
                      :state="validateState('gender')"
                      aria-describedby="input-5-live-feedback"
                    />
                    <p
                      v-if="staticForm.ordererDto.gender == null && isButtonSubmited == true"
                      style="color: red"
                    >
                      {{ $t('This_is_a_required_field') }}
                    </p>
                  </b-form-group>

                  <b-form-group :label="`${$t('Email')}`">
                    <b-form-input
                      v-model="$v.staticForm.ordererDto.email.$model"
                      :state="validateState('email')"
                      placeholder="e.g. example@digitbusiness.ch"
                      aria-describedby="input-1-live-feedback"
                    />
                    <b-form-invalid-feedback id="input-1-live-feedback">
                      {{
                        $t('Must_be_email_format')
                      }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group :label="`${$t('PhoneNumber')}`">
                    <vue-phone-number-input
                      v-model="staticForm.ordererDto.telephoneNumber"
                      :default-country-code="staticForm.ordererDto.countryCode"
                      :preferred-countries="['XK', 'DE', 'AL', 'CH']"
                      :error="isPhoneNumberValid == null ? false : isPhoneNumberValid == false ? true : false"
                      @update="getFormattedNumber"
                    />
                  </b-form-group>
                </div>
              </b-collapse>
            </b-tab>
            <b-tab
              :title="$t('BillingAddress')"
            >
              <template #title>
                <strong style="font-weight: 500; color: black">{{ $t("BillingAddress") }}</strong>
              </template>
              <b-collapse
                id="collapse-345"
                visible
              >
                <div
                  class="hello"
                  style="padding-top: 20px"
                >
                  <b-form-group :label="`${$t('Street')}`">
                    <b-form-input
                      v-model="staticForm.billingAddressDto.street"
                      placeholder="e.g. Rexhep Maja"
                      aria-describedby="input-1-live-feedback"
                    />
                    <b-form-invalid-feedback id="input-1-live-feedback">{{
                      $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                    }}</b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group :label="`${$t('HouseNumber')}`">
                    <b-form-input
                      v-model="staticForm.billingAddressDto.houseNumber"
                      type="number"
                      step="any"
                      min="0"
                      placeholder="e.g. 30"
                      aria-describedby="input-1-live-feedback"
                    />
                    <b-form-invalid-feedback id="input-1-live-feedback"> {{
                      $t('This_is_a_required_field_and_must_contains_numbers')
                    }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group :label="`${$t('DoorNumber')}`">
                    <b-form-input
                      v-model="staticForm.billingAddressDto.doorNumber"
                      type="number"
                      placeholder="e.g. 50"
                      step="any"
                      min="0"
                      aria-describedby="input-1-live-feedback"
                    />
                    <b-form-invalid-feedback id="input-1-live-feedback">{{
                      $t('This_is_a_required_field_and_must_contains_numbers')
                    }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="hello">

                  <b-form-group :label="`${$t('PostalCode')}`">
                    <b-form-input
                      v-model="staticForm.billingAddressDto.postalCode"
                      min="0"
                      placeholder="e.g. 10000"
                      aria-describedby="input-1-live-feedback"
                    />
                    <b-form-invalid-feedback id="input-1-live-feedback">{{
                      $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                    }}</b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group :label="`${$t('City')}`">
                    <b-form-input
                      v-model="staticForm.billingAddressDto.city"
                      placeholder="e.g. Prishtinë"
                      aria-describedby="input-1-live-feedback"
                    />
                    <b-form-invalid-feedback id="input-1-live-feedback">{{
                      $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                    }}</b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group :label="`${$t('Country')}`">
                    <b-form-input
                      v-model="staticForm.billingAddressDto.country"
                      placeholder="e.g. Kosovë"
                      aria-describedby="input-1-live-feedback"
                    />
                    <b-form-invalid-feedback id="input-1-live-feedback">{{
                      $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </div>
              </b-collapse>
            </b-tab>
            <b-tab
              :title="$t('ShippingAddress')"
            >
              <template #title>
                <strong style="font-weight: 500; color: black">{{ $t("ShippingAddress") }}</strong>
              </template>
              <b-collapse
                id="collapse-345"
                visible
              >
                <div>
                  <div
                    class="hello"
                    style="padding-top: 20px"
                  >
                    <b-form-group :label="`${$t('Street')}`">
                      <b-form-input
                        v-model="staticForm.shippingAddressDto.street"
                        :disabled="pickUpInStore"
                        placeholder="e.g. Rexhep Maja"
                        aria-describedby="input-1-live-feedback"
                      />
                      <b-form-invalid-feedback>{{
                        $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                      }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group :label="`${$t('HouseNumber')}`">
                      <b-form-input
                        v-model="staticForm.shippingAddressDto.houseNumber"
                        :disabled="pickUpInStore"
                        placeholder="e.g. 30"
                        type="number"
                        step="any"
                        min="0"
                        aria-describedby="input-1-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                        $t('This_is_a_required_field_and_must_contains_numbers')
                      }}
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group :label="`${$t('DoorNumber')}`">
                      <b-form-input
                        v-model="staticForm.shippingAddressDto.doorNumber"
                        :disabled="pickUpInStore"
                        type="number"
                        placeholder="e.g. 50"
                        step="any"
                        min="0"
                        aria-describedby="input-1-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                        $t('This_is_a_required_field_and_must_contains_numbers')
                      }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="hello">

                    <b-form-group :label="`${$t('PostalCode')}`">
                      <b-form-input
                        v-model="staticForm.shippingAddressDto.postalCode"
                        :disabled="pickUpInStore"
                        placeholder="e.g. 10000"
                        min="0"
                        aria-describedby="input-1-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                        $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                      }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group :label="`${$t('City')}`">
                      <b-form-input
                        v-model="staticForm.shippingAddressDto.city"
                        :disabled="pickUpInStore"
                        placeholder="e.g. Prishtinë"
                        aria-describedby="input-1-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                        $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                      }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group :label="`${$t('Country')}`">
                      <b-form-input
                        v-model="staticForm.shippingAddressDto.country"
                        :disabled="pickUpInStore"
                        placeholder="e.g. Kosovë"
                        aria-describedby="input-1-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                        $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                      }}</b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <span
                    class="duplicate-material"
                    @click="duplicateBillingAddress(), resetPickUpInStore()"
                  >
                    {{ $t('SameAsBillingAddress') }}
                  </span>
                </div>
                <p>
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="pickUpInStore"
                    name="checkbox-1"
                    :value="true"
                    :unchecked-value="false"
                    @input="resetShippingAddress()"
                  >
                    {{ $t('GetInStore') }}
                  </b-form-checkbox>
                </p>
              </b-collapse>
            </b-tab>
          </b-tabs>
        </section>
        <section
          class="custom-modal__wrapper"
          style="border-width: 3px;margin-top: 15px"
        >
          <div style="display:flex;gap: 15px;flex-wrap: wrap">
            <div>
              <label>{{ $t('From') }}</label>
              <div style="display: flex;flex-direction: column;">
                <date-picker
                  v-model="from"
                  type="datetime"
                  :placeholder="$t('SelectD')"
                  format="YYYY-MM-DD HH:mm"
                  :default-value="defaultTime"
                />
                <p
                  v-if="from == null && isButtonSubmited"
                  style="color: red;padding-top: 5px;
                    margin-bottom: 0px;"
                >
                  {{ $t('SelectD') }}
                </p>
              </div>
            </div>
            <div
              style="display: flex;gap:10px;"
            >
              <div class="number-steps">
                <label class="number-steps__label">{{ $t('DurationHour') }}</label>
                <div class="number-steps__input">
                  <b-form-input
                    v-model.number="durationTimeHour"
                    type="number"
                    :placeholder="$t('Hour')"
                  />
                  <div class="number-steps__buttons">
                    <b-icon-plus-circle
                      class="number-steps__button--increase"
                      @click="addHour"
                    />
                    <b-icon-dash-circle
                      class="number-steps__button--decrease"
                      @click="substractHour"
                    />
                  </div>
                </div>
              </div>
              <div class="number-steps">
                <label class="number-steps__label">{{ $t('DurationMinutes') }}</label>
                <div class="number-steps__input">
                  <b-form-input
                    v-model.number="durationTimeMinutes"
                    type="number"
                    :placeholder="$t('Minutes')"
                  />
                  <div class="number-steps__buttons">
                    <b-icon-plus-circle
                      class="number-steps__button--increase"
                      @click="addMinutes"
                    />
                    <b-icon-dash-circle
                      class="number-steps__button--decrease"
                      @click="substractMinutes"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label>{{ $t('To') }}</label>
              <div style="display: flex;flex-direction: column;">
                <date-picker
                  v-model="to"
                  type="datetime"
                  :placeholder="$t('SelectD')"
                  format="YYYY-MM-DD HH:mm"
                  disabled
                />
                <p
                  v-if="to == null && isButtonSubmited"
                  style="color: red;padding-top: 5px;
                    margin-bottom: 0px;"
                >
                  {{ $t('SelectD') }}
                </p>
              </div>
            </div>
            <div style="display:flex;flex-direction:column;width:20%">
              <StoresDropdown
                :filiale="filiale"
                :hide-label="false"
                style="width: 100%;"
                @updateFiliale="updateFiliale"
              />
              <p
                v-if="(filiale.storeId == null || filiale.storeId == '00000000-0000-0000-0000-000000000000') && isButtonSubmited"
                style="color:red;"
              >
                {{ $t('SelectStore') }}
              </p>
            </div>

            <b-form-group
              :label="$t('Users')"
              style="width:30%"
            >
              <vue-select
                v-model="userIds"
                :options="formatedUsers"
                :multiple="true"
                label="fullName"
                :reduce="(e) => e.userId"
                :placeholder="$t('Select')"
              />
            </b-form-group>
          </div>
        </section>
        <section
          class="custom-modal__wrapper"
          style="border-width: 3px;margin-top: 15px"
        >
          <div style="display:flex;flex-direction:column;padding:5px;">
            <table
              class="team_table"
            >
              <thead>
                <tr>
                  <th>{{ $t('paidAmount') }}</th>
                  <th>{{ $t('Account') }}</th>
                  <th>{{ $t('GeneratePDFas') }}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width:30% !important;">
                    <div style="display:flex;margin-top:2px;">
                      <b-input
                        v-model.number="paidAmount"
                        type="number"
                        min="0"
                        style="width:220px;"
                      />
                      <b-form-select
                        v-model="currency"
                        dropup
                        required
                        :options="currencies"
                        aria-placeholder="Select order type"
                        aria-describedby="input-1-live-feedback"
                        style="display: block;
                          padding: 0.469rem 0.75rem;
                          font-size: 1rem;
                          font-weight: 400;
                          line-height: 1.5;
                          color: #212529;
                          background-color: #fff;
                          background-clip: padding-box;
                          border: 1px solid #ced4da;
                          border-radius: 0.25rem;
                          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;"
                      />
                    </div>
                    <p
                      v-if="paidAmount < 0 && isButtonSubmited"
                      style="color:red;"
                    >
                      {{ $t('This_is_a_required_field') }}
                    </p>
                  </td>
                  <td>
                    <div>
                      <vue-select
                        v-model="accountId"
                        :options="getAccountDetails"
                        :reduce="(e) => e.accountId"
                        label="name"
                        :placeholder="$t('Select')"
                        style="width: 100%;"
                        :disabled="paidAmount < 0 || paidAmount == 0"
                      />
                      <p
                        v-if="paidAmount > 0 && accountId == null"
                        style="color:red;"
                      >
                        {{ $t('SelectAccount') }}
                      </p>
                    </div>
                  </td>
                  <td>
                    <div>
                      <vue-select
                        v-model="pdfText"
                        :options="[
                          { label: $t('DontGenerate'), value: 'DontGenerate' },
                          { label: $t('Avans'), value: 'Avans' },
                          { label: $t('Offer'), value: 'Offer' },
                        ]"
                        :reduce="option => option.value"
                        :clearable="false"
                        label="label"
                        :placeholder="$t('Select')"
                        aria-describedby="input-1-live-feedback"
                        style="width: 100%;"
                      />
                    </div>
                  </td>
                  <td />
                </tr>
              </tbody>
            </table>
            <b-form-group
              :label="$t('InvoiceRemark')"
              style="width:100%;"
            >
              <b-form-textarea
                v-model="invoiceRemark"
                style="width:100%"
                :placeholder="$t('Write...')"
              />
            </b-form-group>
          </div>
        </section>

        <div class="buttonsEverywhere">
          <button
            type="button"
            variant="none"
            style="margin-top: 20px;"
            class="buttonSubmit"
            :disabled="loading"
            @click="onSubmit()"
          >
            <div
              v-if="loading"
              style="width:100%"
              class="pdf-spinner-overlay"
            >
              <span class="loader" />
            </div>
            {{ $t('Submit') }}
          </button>
          <b-button
            type="reset"
            variant="danger"
            class="buttonCancel"
            style="margin-right: 15px; margin-top: 20px; background: white; color: black; border-color: white;font-weight: 400;"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import {
  required, minLength, email,
} from 'vuelidate/lib/validators';

import AWS from 'aws-sdk';
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import jsPDF from 'jspdf';
import {
  xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo,
} from '@/components/iconsImageUsers';
import { AWSurl, client } from '../domainConfig';
import 'vue2-datepicker/index.css';
import StoresDropdown from '../components/StoresDropdown.vue';
import 'jspdf-autotable';

export default {
  components: {
    DatePicker,
    StoresDropdown,
  },
  mixins: [validationMixin],
  // eslint-disable-next-line vue/require-prop-types
  props: ['nextYearClicked', 'nextMonthClicked', 'nextDayClicked', 'titleOfCalendar'],
  id: {
    type: Object,
  },
  data() {
    return {
      defaultTime: new Date().setHours(8, 0, 0, 0),
      pdfText: 'Avans',
      paidAmount: 0,
      accountId: null,
      currency: '€',
      currencies: ['€', '$', 'CHF'],
      invoiceRemark: null,
      selectedVAT: 18,
      vatOptions: [
        { text: '18%', value: 18 },
        { text: '8%', value: 8 },
        { text: '0%', value: 0 },
      ],
      filiale: { storeId: null, storeName: 'No filiale', storeGLN: null },
      oldFiliale: { storeId: null, storeName: 'No filiale', storeGLN: null },
      newUsers: [],
      durationTimeMinutes: 0,
      durationTimeHour: 0,
      appointmentType: 'Measurement',
      userIds: [],
      to: null,
      from: null,
      isButtonSubmited: false,
      clienti: client.clientName,
      client: false,
      loading: false,
      arrowCounter: 0,
      enterPressed: false,
      searchClients: null,
      clientId: '00000000-0000-0000-0000-000000000000',
      noSearch: false,
      isPhoneNumberValid: null,
      config: {
        altInput: true,
        altFormat: 'd-m-Y',
        dateFormat: 'Y-m-d',
      },
      pickUpInStore: false,
      salutation: ['Mr.', 'Ms.'],
      staticForm: {
        ordererDto: {
          salutation: null,
          firstName: '',
          lastName: '',
          email: '',
          gender: null,
          telephoneNumber: '',
          countryCode: 'XK',
        },
        billingAddressDto: {
          street: '',
          houseNumber: '',
          doorNumber: '',
          postalCode: '',
          city: '',
          country: '',
        },
        shippingAddressDto: {
          street: '',
          houseNumber: '',
          doorNumber: '',
          postalCode: '',
          city: '',
          country: '',
        },
      },
      description: '',
      addressOfClient: null,
      addressOfStore: null,
      nameOfClient: null,
      emailOfClient: null,
      phoneOfClient: null,
      orderNumber: null,
      taxPrice: 0,
      totalPrice: 0,
      shipmentPrice: null,
      shipmentCode: null,
      remark: null,
    };
  },

  validations: {
    staticForm: {
      ordererDto: {
        salutation: {
          required,
        },
        firstName: {
          required,
          minLength: minLength(3),
        },
        lastName: {
          required,
          minLength: minLength(3),
        },
        email: {
          email,
        },
        gender: {
          required,
        },
      },
    },
  },
  computed: {
    ...mapGetters(['getClients',
      'getOrderTypes',
      'getMeasermentsById',
      'getFirstNames',
      'getTotalItemsForClients',
      'getClient',
      'getLanguage',
      'getAccountDetails',
      'getAllStoresDropdown',
      'getRegularEmployeesById',
      'getUsersMultipleRoles',
      'getLoggedInUser',
      'getNewInvoiceByOrderNumber',
      'getUsersActiveInactive']),
    formatedUsers() {
      const regularEmployees = this.getRegularEmployeesById.map((item) => {
        return {
          fullName: `${item.name}`,
          userId: item.userId,
        }
      });
      const uniqueNewUsers = this.newUsers.filter((newItem) => { return !regularEmployees.some((existingItem) => { return existingItem.userId === newItem.userId }) });
      return [...regularEmployees, ...uniqueNewUsers];
    },
  },
  watch: {
    'getLoggedInUser.storeId': function () {
      this.updateFiliale();
    },
    paidAmount(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value < 0 || value == '' || value == null) {
          this.paidAmount = 0
          this.accountId = null
        }
      }, 0);
    },
    from(value) {
      if (value == null) {
        this.durationTimeHour = 0;
        this.durationTimeMinutes = 0;
        this.to = null;
      } else {
        this.calculateDuration();
      }
    },
    to(value) {
      if (value) {
        this.calculateDuration();
      }
    },
    durationTimeHour(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value < 0) {
          this.durationTimeHour = 0;
        } else if (value === '') {
          this.durationTimeHour = 0;
        } else {
          const fullHours = Math.floor(value);
          const fractionalPart = value - fullHours;

          this.durationTimeHour = fullHours;
          this.durationTimeMinutes += Math.round(fractionalPart * 60);
        }
        this.calculateMontageEnd();
      }, 0);
    },
    durationTimeMinutes(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value < 0) {
          this.durationTimeMinutes = 0;
        }
        if (value == '') {
          this.durationTimeMinutes = 0;
        }
        if (value >= 60) {
          const totalHours = Math.floor(value / 60);
          this.durationTimeHour += totalHours;

          const fractionalPart = (value / 60) - totalHours;
          const remainingMinutes = Math.round(fractionalPart * 60);

          this.durationTimeMinutes = remainingMinutes;
        }
        if (value < 0 && this.durationTimeHour > 0) {
          this.durationTimeHour -= 1;
          this.durationTimeMinutes = 45;
        }
        this.calculateMontageEnd();
      }, 0);
    },
    pickUpInStore(value) {
      if (value == true) {
        this.staticForm.shippingAddressDto.street = '';
        this.staticForm.shippingAddressDto.houseNumber = '';
        this.staticForm.shippingAddressDto.doorNumber = '';
        this.staticForm.shippingAddressDto.postalCode = '';
        this.staticForm.shippingAddressDto.city = '';
        this.staticForm.shippingAddressDto.country = '';
      }
    },
    searchClients(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value == null) {
          this.clearCustomMeasurements();
          this.removeLists();
        } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
          return;
        } else {
          this.firstNames(value);
          this.noSearch = true
        }
      }, 500);
    },
    filiale(value) {
      this.loadRegularEmployeesId({ storeId: value.storeId })
      this.userIds = []
    },
  },
  created() {
    AWS.config.update({
      accessKeyId: AWSurl.accessKeyId,
      secretAccessKey: AWSurl.secretAccessKey,
      region: AWSurl.region,
    });

    this.s3 = new AWS.S3();
  },
  mounted() {
    this.accountDetails({ isActive: true, bankId: null })
  },
  methods: {
    ...mapActions([
      'usersByMultipleRoles', 'loadInvoiceByOrderItem', 'accountDetails', 'loadRegularEmployeesId', 'loadAllStoresByDropdown', 'loadMontageAppointments', 'createAppointment', 'resetCustomOrders', 'clearCustomMeasurements', 'loadOrderTypes', 'editClient', 'getClientById', 'getClientsPagination', 'getClientById', 'firstNames', 'resetSearchClients', 'loadMeasermentsById',
    ]),
    updateFiliale(newFiliale) {
      this.filiale = newFiliale;
    },
    calculateDuration() {
      if (this.from && this.to) {
        const fromDate = new Date(this.from);
        const toDate = new Date(this.to);

        const diff = toDate - fromDate;

        const durationHours = Math.floor(diff / (1000 * 60 * 60));
        const durationMinutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        this.durationTimeHour = durationHours;
        this.durationTimeMinutes = durationMinutes;
      }
    },

    calculateMontageEnd() {
      if (this.from && this.durationTimeHour != null && this.durationTimeMinutes != null) {
        const startDate = new Date(this.from);

        startDate.setHours(startDate.getHours() + this.durationTimeHour);
        startDate.setMinutes(startDate.getMinutes() + this.durationTimeMinutes);

        startDate.setSeconds(0);

        this.to = startDate;

        console.log('Montage End:', this.to);
      }
    },

    addHour() {
      this.durationTimeHour++;
      this.calculateMontageEnd();
    },

    substractHour() {
      this.durationTimeHour--;
      this.calculateMontageEnd();
    },

    addMinutes() {
      this.durationTimeMinutes += 15;
      this.calculateMontageEnd();
    },

    substractMinutes() {
      this.durationTimeMinutes -= 15;
      this.calculateMontageEnd();
    },
    addNewClient() {
      this.client = true;
    },
    getFormattedNumber(n) {
      if (n.isValid == true) {
        this.isPhoneNumberValid = true
        this.staticForm.ordererDto.telephoneNumber = n.nationalNumber
        this.staticForm.ordererDto.countryCode = n.countryCode
      } else {
        this.staticForm.ordererDto.countryCode = ''
        this.isPhoneNumberValid = false
        return;
      }
      console.log()
    },
    async searchByOn(value) {
      this.noSearch = false
      const clientData = await this.getClientById({
        clientId: value,
        successCallback: () => {
        },
      })
      this.searchClients = `${clientData.firstName} ${clientData.lastName}`
      this.clientId = value
      this.staticForm.ordererDto.salutation = clientData.salutation
      this.staticForm.ordererDto.firstName = clientData.firstName
      this.staticForm.ordererDto.lastName = clientData.lastName
      this.staticForm.ordererDto.gender = clientData.gender
      this.staticForm.ordererDto.email = clientData.email
      this.staticForm.ordererDto.telephoneNumber = clientData.telephoneNumber
      this.staticForm.ordererDto.countryCode = clientData.countryCode
      this.staticForm.ordererDto.taxRate = clientData.taxRate
      this.staticForm.billingAddressDto.street = clientData.billingAddressDto.street
      this.staticForm.billingAddressDto.houseNumber = clientData.billingAddressDto.houseNumber
      this.staticForm.billingAddressDto.doorNumber = clientData.billingAddressDto.doorNumber
      this.staticForm.billingAddressDto.postalCode = clientData.billingAddressDto.postalCode
      this.staticForm.billingAddressDto.city = clientData.billingAddressDto.city
      this.staticForm.billingAddressDto.country = clientData.billingAddressDto.country
      this.staticForm.shippingAddressDto.street = clientData.shippingAddressDto.street
      this.staticForm.shippingAddressDto.houseNumber = clientData.shippingAddressDto.houseNumber
      this.staticForm.shippingAddressDto.doorNumber = clientData.shippingAddressDto.doorNumber
      this.staticForm.shippingAddressDto.postalCode = clientData.shippingAddressDto.postalCode
      this.staticForm.shippingAddressDto.city = clientData.shippingAddressDto.city
      this.staticForm.shippingAddressDto.country = clientData.shippingAddressDto.country
    },
    removeLists() {
      this.noSearch = false;
      this.resetSearchClients();
    },
    onArrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFirstNames.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },

    onArrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getFilteredActiveUsers = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOn(this.getFirstNames[this.arrowCounter].clientId)
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      console.log(liH)
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.staticForm.ordererDto[name];
      return $dirty ? !$error : null;
    },
    resetPickUpInStore() {
      this.pickUpInStore = false
    },
    duplicateBillingAddress() {
      this.staticForm.shippingAddressDto.street = this.staticForm.billingAddressDto.street;
      this.staticForm.shippingAddressDto.houseNumber = this.staticForm.billingAddressDto.houseNumber;
      this.staticForm.shippingAddressDto.doorNumber = this.staticForm.billingAddressDto.doorNumber;
      this.staticForm.shippingAddressDto.postalCode = this.staticForm.billingAddressDto.postalCode;
      this.staticForm.shippingAddressDto.city = this.staticForm.billingAddressDto.city;
      this.staticForm.shippingAddressDto.country = this.staticForm.billingAddressDto.country;
    },

    async onSubmit() {
      this.isButtonSubmited = true
      this.$v.staticForm.ordererDto.$touch();
      if (this.$v.staticForm.ordererDto.$anyError) {
        return;
      }
      if ((this.filiale.storeId == null || this.filiale.storeId == '00000000-0000-0000-0000-000000000000')) {
        return
      }
      if (this.from == null || this.to == null) {
        return;
      }
      if (this.paidAmount > 0 && this.accountId == null) {
        return
      }
      const objekti = {
        ordererDto: this.staticForm.ordererDto,
        billingAddressDto: this.staticForm.billingAddressDto,
        shippingAddressDto: this.staticForm.shippingAddressDto,
        clientId: this.clientId,
        from: this.from,
        to: this.to,
        appointmentType: this.appointmentType,
        userIds: this.userIds,
        storeId: this.filiale.storeId,
        createOrderWithoutItemsRequestDto: {
          paidAmount: this.paidAmount,
          currency: this.currency,
          invoiceRemark: this.invoiceRemark,
          accountId: this.accountId,
          taxRate: this.selectedVAT,
        },
      }
      try {
        this.loading = true
        await this.createAppointment({
          object: objekti,
          successCallback: (response) => {
            if (this.nextDayClicked) {
              this.loadMontageAppointments({
                start: moment(this.titleOfCalendar).startOf('day').format('YYYY-MM-DD'),
                end: moment(this.titleOfCalendar).add(7, 'days').format('YYYY-MM-DD'),
              })
            } else if (this.nextMonthClicked) {
              this.loadMontageAppointments({
                start: moment(this.titleOfCalendar).startOf('month').format('YYYY-MM-DD'),
                end: moment(this.titleOfCalendar).endOf('month').format('YYYY-MM-DD'),
              })
            } else if (this.nextYearClicked) {
              this.loadMontageAppointments({
                start: moment(this.titleOfCalendar).startOf('year').format('YYYY-MM-DD'),
                end: moment(this.titleOfCalendar).add(1, 'year').format('YYYY-MM-DD'),
              })
            }
            if (this.pdfText !== 'DontGenerate') {
              this.downloadInvoiceNew(response);
            } else {
              this.$refs.modal.hide();
              this.resetForm()
              this.resetCustomerData()
              this.selectedVAT = 18;
              this.loading = false
            }
          },
        })
      } catch (error) {
        this.loading = false
      }
    },
    downloadInvoiceNew(value, value1) {
      this.dateOfCreated = value1
      this.orderNumberClient = value
      this.loadInvoiceByOrderItem({
        orderId: value,
      })
        .then(() => {
          const invoice = this.getNewInvoiceByOrderNumber;
          const tableContent = this.generateInvoiceTableContentNew(invoice);
          const pdfDocument = this.generateInvoiceNew(tableContent, xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo, 800);
          this.$refs.modal.hide();
          this.resetForm()
          this.resetCustomerData()
          this.selectedVAT = 18;
          this.loading = false
          // Save the PDF
          const pdfBlob = pdfDocument.output('blob');
          const blobUrl = URL.createObjectURL(pdfBlob);

          // Save the Blob URL to localStorage or sessionStorage
          sessionStorage.setItem('pdfBlobUrl', blobUrl);
          sessionStorage.setItem('pathName', this.$route.path);

          // Navigate to the PDF preview page using Vue Router
          this.$router.push({ name: 'Pdf Preview' });
        })
        .catch((error) => {
          this.$refs.modal.hide();
          this.resetForm()
          this.resetCustomerData()
          this.selectedVAT = 18;
          this.loading = false
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    previewPdf(blobUrl) {
      // Assuming you have an iframe in your HTML to show the PDF preview
      const iframe = document.getElementById('pdf-preview');
      if (iframe) {
        iframe.src = blobUrl;
      } else {
        console.error('PDF preview iframe not found.');
      }
    },
    generateInvoiceTableContentNew(invoice) {
      // Define table headers
      const headers = [
        `${this.$t('No.')}`,
        `${this.$t('Barcode')}`,
        `${this.$t('ArticleNumber')}`,
        `${this.$t('Unit1')}`,
        `${this.$t('Quantity')}`,
        `${this.$t('Price')}`,
        `${this.$t('Discount')}`,
        `${this.$t('PriceWithDiscount')}`,
        `${this.$t('TotalPriceInvoice')}`,
      ];

      // Extract header details
      const {
        headerDto, itemsDto, clientDetailsResponseDto,
      } = invoice;

      // Extract client details
      this.nameOfClient = clientDetailsResponseDto.clientName;
      this.emailOfClient = clientDetailsResponseDto.email;
      this.phoneOfClient = clientDetailsResponseDto.telephoneNumber;
      this.addressOfClient = {
        street: clientDetailsResponseDto.addressDto?.street || this.$t('NotFound'),
        city: clientDetailsResponseDto.addressDto?.city || this.$t('NotFound'),
        postalCode: clientDetailsResponseDto.addressDto?.postalCode || this.$t('NotFound'),
        country: clientDetailsResponseDto.addressDto?.country || this.$t('NotFound'),
      };
      this.addressOfStore = {
        street: headerDto.storeDetail?.street || this.$t('NotFound'),
        city: headerDto.storeDetail?.city || this.$t('NotFound'),
        postalCode: headerDto.storeDetail?.postalCode || this.$t('NotFound'),
        country: headerDto.storeDetail?.country || this.$t('NotFound'),
        storeName: headerDto.storeDetail?.storeName || this.$t('NotFound'),
      }

      // Extract header information
      this.orderNumber = headerDto.orderNumber;
      this.sellDate = headerDto.sellDate;
      this.totalPrice = ((headerDto.totalPrice || 0) - (headerDto.discount || 0)).toFixed(2);
      this.discount = headerDto.discount;
      this.selectedVAT = headerDto.taxRate;
      this.shipmentPrice = headerDto.discount?.toFixed(2) ?? '0.00';
      this.shipmentCode = headerDto.shipmentCode;
      this.paidAmount = headerDto.paidAmount?.toFixed(2);
      this.remark = headerDto?.invoiceRemark ? headerDto?.invoiceRemark : '';
      this.taxPrice = parseFloat((this.totalPrice - (this.totalPrice / (1 + this.selectedVAT / 100))).toFixed(2))

      // Map items to table body
      const body = itemsDto.map((item, index) => {
        return [
          index + 1,
          item.barcode || this.$t('NoBarcode'),
          item.articleNumber,
          item.type,
          item.quantity,
            item.price?.toFixed(2),
            item.price?.toFixed(2) - item.priceWithDiscount?.toFixed(2),
            item.priceWithDiscount?.toFixed(2),
            (item.quantity * item.priceWithDiscount).toFixed(2),
        ];
      });

      return {
        headers,
        body,
      };
    },
    generateInvoiceNew(tableContent, firstIcon, secondIcon, thirdIcon, fourthIcon, fifthIcon, sixthIcon, customWidth) {
      const { headers, body } = tableContent;

      // Split the body into chunks of 5 rows each
      const rowsPerPageFirst = 9;
      const rowsPerPageOther = 16;

      const getTotalPages = (bodys) => {
        const totalRows = bodys.length;
        // First page shows 10 rows
        const remainingRows = totalRows - rowsPerPageFirst;
        // For the remaining rows, we will calculate how many full pages of 15 rows fit
        const otherPages = remainingRows > 0 ? Math.ceil(remainingRows / rowsPerPageOther) : 0;
        // Total pages is the first page plus any additional pages needed for the remaining rows
        return 1 + otherPages;
      };

      const totalPages = getTotalPages(body);

      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: [750, 900],
      });

      // Set custom width after creating the doc instance
      doc.setProperties({
        format: [customWidth, doc.internal.pageSize.getHeight()],
      });

      const staticContent = () => {
        const title = this.$t(this.pdfText);
        const titleY = 90;
        const titleX = 40;
        doc.setFontSize(30);
        doc.setFont('Helvetica', 'normal');
        doc.setTextColor(0, 0, 0);
        doc.text(title, titleX, titleY, { align: 'left' });

        const iconWidth = 150;
        const iconHeight = 100;
        const iconY = 50;
        const iconX = doc.internal.pageSize.getWidth() - 180;
        doc.addImage(firstIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

        // Location and Phone details
        const locations = [
          { name: 'PRISHTINË - Çagllavicë', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
          { name: 'GJILAN', name2: 'Përball FSK-së', phone: '+383 44 991 994' },
          { name: 'PRIZREN', name2: 'Lubizhdë - Km. 1', phone: '+383 43 778 778' },
          { name: 'FERIZAJ - Magj.', name2: 'Ferizaj-Prishtinë - Km. 1', phone: '+383 49 640 940' },
          { name: 'PRISHTINË 2', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
        ];

        const locationsY = doc.internal.pageSize.getHeight() - 90; // Start just above the footer
        const locationSpacing = 132; // Space between each location block

        const startXPosition = 40; // Starting position for the first location
        const endXPosition = startXPosition + (locations.length - 1) * locationSpacing + 132; // End X position based on number of locations

        // Loop through the locations array and display each one
        locations.forEach((location, index) => {
          const xPosition = 40 + index * locationSpacing; // Adjust X position for each location
          doc.setFontSize(8);
          doc.setTextColor(0, 0, 0); // Black color

          // Add the location icon
          const iconXPosition = xPosition - 25; // Position the icon just before the location name
          const iconYPosition = locationsY - 10; // Position the icon just above the location name
          doc.addImage(secondIcon, 'PNG', iconXPosition, iconYPosition, 28, 29); // Icon size 10x10 (adjust as needed)

          // Display the location name
          doc.text(location.name, xPosition, locationsY);

          doc.text(location.name2, xPosition, locationsY + 15);

          // Display the phone number below the location name
          doc.text(location.phone, xPosition, locationsY + 30); // Position phone number below the location name
        });

        // Add a line under the locations block, spanning the width of the locations
        doc.setDrawColor(0, 0, 0); // Black color for the line
        const lineY = locationsY + 40; // Position the line just below the last location's phone number
        doc.line(startXPosition, lineY, endXPosition, lineY); // Draw a line across the width of the locations

        // Show the three items in a row below the line
        const itemsXStart = 40; // Starting position for the row of items
        const itemsY = lineY + 3; // Y-position for the items row

        const items = [
          { icon: fourthIcon, text: 'NOTAbrillantOfficial' },
          { icon: fifthIcon, text: 'nota.brillant' },
          { icon: sixthIcon, text: 'info@notabrillantofficial.com' },
        ];

        // Space between each item in the row
        const itemSpacing = 150; // Adjust this for the space between icons and text

        items.forEach((item, index) => {
          const xPosition = itemsXStart + index * itemSpacing; // Calculate horizontal position for each item

          // Add the icon and text next to each other
          doc.addImage(item.icon, 'PNG', xPosition, itemsY, 20, 20); // Icon position and size
          doc.setFontSize(12);
          doc.text(item.text, xPosition + 25, itemsY + 15); // Position text next to the icon (adjust the X offset if needed)
        });

        // QR code section
        const qrCodeText = 'Blej online';
        const qrCodeTextWidth = doc.getTextWidth(qrCodeText);
        const qrCodeTextX = 680 + (45 - qrCodeTextWidth) / 2; // Center the text above the QR code
        const qrCodeTextY = doc.internal.pageSize.getHeight() - 60; // Adjust the Y position to place text above the QR code
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0); // Black color
        doc.text(qrCodeText, qrCodeTextX, qrCodeTextY);

        // Add the QR code image
        doc.addImage(thirdIcon, 'PNG', 680, doc.internal.pageSize.getHeight() - 50, 45, 45);

        // Footer section
        const footerText = 'Powered by DigIT';
        const footerTextWidth = doc.getTextWidth(footerText);
        const centerX = (doc.internal.pageSize.getWidth() - footerTextWidth) / 2;
        const footerY = doc.internal.pageSize.getHeight() - 10;

        doc.setFontSize(10);
        doc.setTextColor(160, 160, 160);
        doc.text(footerText, centerX, footerY);
      };





      // Function to render the table for a specific page
      const renderTable = (pageIndex) => {
        const rowsPerPage = pageIndex === 0 ? rowsPerPageFirst : rowsPerPageOther;

        // Calculate the starting and ending rows for this page
        const startRow = pageIndex === 0 ? 0 : rowsPerPageFirst + (pageIndex - 1) * rowsPerPage;
        const endRow = startRow + rowsPerPage;

        // Ensure we do not go out of bounds by adjusting the end row if necessary
        const tableBody = body.slice(startRow, Math.min(endRow, body.length));

        const tableOptions = {
          startY: pageIndex === 0 ? 430 : 250, // First page starts lower, subsequent pages start from the top
          head: [headers],
          body: tableBody,
          headStyles: {
            fillColor: [249, 249, 249],
            textColor: [96, 96, 96],
            lineColor: [181, 181, 181],
            lineWidth: 0.1,
            halign: 'left',
          },
          bodyStyles: {
            textColor: [0, 0, 0],
            lineWidth: 0.1,
          },
          pageBreak: 'auto',
          columnStyles: {
            0: { columnWidth: doc.internal.pageSize.getWidth() / 20, halign: 'left', fillColor: [255, 255, 255] },
            1: { columnWidth: doc.internal.pageSize.getWidth() / 6, halign: 'left', fillColor: [255, 255, 255] },
            2: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
            3: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
            4: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
            5: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
            6: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
            7: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
            8: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
          },
          afterPageContent: staticContent,
        };

        doc.autoTable(tableOptions);
      };

      // Only render the static content (title, icon, etc.) on the first page
      const renderStaticContent = () => {
        const from = this.$t('From');
        const fromY = 160;
        const fromX = 40;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(from, fromX, fromY, { align: 'left' });

        const lineStartX = fromX;
        const lineEndX = 300; // Adjust to your desired width
        const lineY = fromY + 5; // Add some spacing below "From"
        doc.setDrawColor(160, 160, 160); // Set line color to gray
        doc.setLineWidth(0.3); // Adjust thickness of the line
        doc.line(lineStartX, lineY, lineEndX, lineY);

        const author4X = fromX;
        const author4Y = 180;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(`${this.clienti}`, author4X, author4Y);

        let phone;
        let emails
        let url
        if (this.clienti === 'NotaBrillant') {
          phone = '+383 44 117 090';
          emails = 'kujdesi@nota-brillant.com'
          url = 'nota-brillant.com'
        } else {
          phone = '+383 49 999 433';
          emails = 'contacts@digitbusiness.ch'
          url = 'digitbusiness.ch'
        }

        const phoneX = fromX;
        const phoneY = 200;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(phone, phoneX, phoneY);

        const emailX = fromX;
        const emailY = 220;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(emails, emailX, emailY);

        const addressX = fromX;
        const addressY = 240;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(
          `${this.addressOfStore?.city}, ${this.addressOfStore?.street}, ${this.$t('Filiale')}:${this.addressOfStore?.storeName}`,
          addressX,
          addressY,
        );

        const urlX = fromX;
        const urlY = 260;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(url, urlX, urlY);

        const date = this.$t('PrintingDate');
        const dateY = 180;
        const dateX = 400;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(date, dateX, dateY, { align: 'left' });

        const todayDate = `${this.$t(moment().format('dddd'))}, ${moment().format('DD-MM-YYYY')}`;
        const todayDateY = dateY + 17;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(todayDate, dateX, todayDateY, { align: 'left' });

        const order = this.$t('OrderNumber');
        const orderY = 255;
        const orderX = 400;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(order, orderX, orderY, { align: 'left' });

        const author14X = 400;
        const author14Y = 275;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(`${this.orderNumber}`, author14X, author14Y, { align: 'left' });

        const sell = this.$t('SellDate');
        const sellY = 215;
        const sellX = 400;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(sell, sellX, sellY, { align: 'left' });

        const author14XSell = 400;
        const author14YSell = 235;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(`${this.sellDate ? this.$t(moment(this.sellDate).format('dddd')) : this.$t('NotFoundDate')}, ${this.sellDate ? moment(this.sellDate).format('DD-MM-YYYY') : this.$t('NotFoundDate')}`, author14XSell, author14YSell, { align: 'left' });

        const to = this.$t('To');
        const toY = 290;
        const toX = 40;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(to, toX, toY, { align: 'left' });

        const toLineStartX = toX;
        const toLineEndX = 300; // Adjust to your desired width
        const toLineY = toY + 5; // Add some spacing below "To"
        doc.setDrawColor(160, 160, 160); // Set line color to gray
        doc.setLineWidth(0.3); // Adjust thickness of the line
        doc.line(toLineStartX, toLineY, toLineEndX, toLineY);

        const author7X = toX;
        const author7Y = 310;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(`${this.nameOfClient}`, author7X, author7Y);

        const author10X = toX;
        const author10Y = 330;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        if (this.phoneOfClient) {
          doc.text(`${this.phoneOfClient}`, author10X, author10Y);
        }

        const author9X = toX;
        const author9Y = 350;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        if (this.emailOfClient) {
          doc.text(`${this.emailOfClient}`, author9X, author9Y);
        }

        const author8X = toX;
        const author8Y = 370;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        if (this.addressOfClient?.city || this.addressOfClient?.street) {
          doc.text(
            `${this.addressOfClient.city || ''}${this.addressOfClient.street ? `, ${this.addressOfClient.street}` : ''}`,
            author8X,
            author8Y,
          );
        }
      };

      // Render the first page's static content and table
      renderStaticContent();
      renderTable(0);

      // Render subsequent pages with the table
      for (let i = 1; i < totalPages; i++) {
        doc.addPage(); // Add a new page for each set of rows
        renderTable(i);
      }

      // Add a line below the table
      const tableEndY = doc.lastAutoTable.finalY; // Get the y-coordinate where the table ends
      const lineStartTabX = 40; // Start x-coordinate of the line
      const lineEndTabX = doc.internal.pageSize.getWidth() - 40; // End x-coordinate of the line (full width with some margin)
      const lineTabY = tableEndY + 26; // Add spacing below the table

      doc.setFontSize(10);
      doc.setTextColor(255, 99, 99);
      doc.text('Vërejtje: Produktet mund të ndërrohen vetëm brenda 48h, pas pranimit të produktit.', 40, tableEndY + 15);


      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartTabX, lineTabY, lineEndTabX, lineTabY); // Use the correct variable

      const totalRemainingAmount = (this.totalPrice - this.paidAmount).toFixed(2);

      const totalPriceY = lineTabY + 15; // Add spacing below the line for TotalPrice
      const totalPaidY = totalPriceY + 25; // Add spacing below TotalPrice for TotalPaid


      // TotalPrice label
      const totalPriceLabelX = 600;
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text(`${this.$t('TotalPrice')}`, totalPriceLabelX, totalPriceY, { align: 'right' });

      // TotalPrice value
      const totalPriceValueX = 670;
      doc.text(`${this.totalPrice}€`, totalPriceValueX, totalPriceY, { align: 'right' });

      // Add a line below the TotalPrice value
      const lineStartPriceX = totalPriceValueX - 62; // Start X-coordinate slightly left of the value
      const lineEndPriceX = totalPriceValueX + 40; // End X-coordinate slightly right of the value
      const linePriceY = totalPriceY + 4; // Line Y-coordinate, slightly below the value
      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartPriceX, linePriceY, lineEndPriceX, linePriceY);

      // TotalPaid label
      const totalPaidLabelX = 600;
      doc.setFontSize(10);
      doc.text(`${this.$t('TotalPaid')}`, totalPaidLabelX, totalPaidY, { align: 'right' });

      // TotalPaid value
      const totalPaidValueX = 670;
      doc.text(`${this.paidAmount}€`, totalPaidValueX, totalPaidY, { align: 'right' });

      // Add a line below the TotalPaid value
      const lineStartPaidX = totalPaidValueX - 62; // Start X-coordinate slightly left of the value
      const lineEndPaidX = totalPaidValueX + 40; // End X-coordinate slightly right of the value
      const linePaidY = totalPaidY + 4; // Line Y-coordinate, slightly below the value
      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartPaidX, linePaidY, lineEndPaidX, linePaidY);

      // RemainingAmount label
      const remainingAmountLabelX = 600;
      doc.setFontSize(10);
      const remainingAmountY = totalPaidY + 25; // Position RemainingAmount below TotalPaid
      doc.text(`${this.$t('RemainingAmount')}`, remainingAmountLabelX, remainingAmountY, { align: 'right' });

      // RemainingAmount value
      const remainingAmountValueX = 670;
      doc.text(`${totalRemainingAmount < 0 ? 0 : totalRemainingAmount}€`, remainingAmountValueX, remainingAmountY, { align: 'right' });

      // Add a line below the RemainingAmount value
      const lineStartRemX = remainingAmountValueX - 62; // Start X-coordinate slightly left of the value
      const lineEndRemX = remainingAmountValueX + 40; // End X-coordinate slightly right of the value
      const lineRemY = remainingAmountY + 4; // Line Y-coordinate, slightly below the value
      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartRemX, lineRemY, lineEndRemX, lineRemY);

      const taxRateLabelX = 600;
      doc.setFontSize(10);
      const taxRateY = remainingAmountY + 25; // Position TaxRate below RemainingAmount
      doc.text(`${this.$t('TVSH')}-${this.selectedVAT}%`, taxRateLabelX, taxRateY, { align: 'right' });

      // TaxRate value
      const taxRateValueX = 670;
      doc.text(`${this.taxPrice}€`, taxRateValueX, taxRateY, { align: 'right' });

      // Add a line below the TaxRate value
      const lineStartTaxX = taxRateValueX - 62; // Start X-coordinate slightly left of the value
      const lineEndTaxX = taxRateValueX + 40; // End X-coordinate slightly right of the value
      const lineTaxY = taxRateY + 4; // Line Y-coordinate, slightly below the value
      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartTaxX, lineTaxY, lineEndTaxX, lineTaxY);

      const shipmentPriceLabelX = 600;
      doc.setFontSize(10);
      const shipmentPriceY = taxRateY + 25; // Position ShipmentPrice below TaxRate
      doc.text(`${this.$t('Discount')}`, shipmentPriceLabelX, shipmentPriceY, { align: 'right' });

      const formattedShipmentPrice = this.shipmentPrice ?? 0;

      // ShipmentPrice value
      const shipmentPriceValueX = 670;
      doc.text(`${formattedShipmentPrice}€`, shipmentPriceValueX, shipmentPriceY, { align: 'right' });

      // Add a line below the ShipmentPrice value
      const lineStartShipX = shipmentPriceValueX - 62; // Start X-coordinate slightly left of the value
      const lineEndShipX = shipmentPriceValueX + 40; // End X-coordinate slightly right of the value
      const lineShipY = shipmentPriceY + 4; // Line Y-coordinate, slightly below the value
      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartShipX, lineShipY, lineEndShipX, lineShipY);

      const addressX1 = 40;
      const addressY1 = lineTabY + 5;
      const rectWidth = 450; // Maximum width for the rectangle
      const rectHeight = 90; // Fixed height for the rectangle

      // Set font size
      doc.setFontSize(10);

      // Set background color for the rectangle (light red)
      doc.setFillColor(173, 173, 173); // RGB for light red
      doc.rect(addressX1, addressY1, rectWidth, rectHeight, 'F'); // Draw the fixed-height rectangle

      // Set text color inside the rectangle (white)

      // Concatenate the label and remark text
      doc.setTextColor(0, 0, 0);
      const labelAndRemark = `${this.$t('InvoiceRemark')}: ${this.remark}`;

      // Calculate the maximum width for the text inside the rectangle
      const textWidth = rectWidth - 10; // Max width with padding

      // Add the concatenated label + remark text inside the rectangle
      doc.text(labelAndRemark, addressX1 + 5, addressY1 + 15, { maxWidth: textWidth, align: 'left' });

      return doc;
    },
    onCancel() {
      this.$refs.modal.hide();
      this.resetCustomerData()
      this.resetForm()
    },
    resetShippingAddress() {
      this.$v.staticForm.shippingAddressDto.$reset()
    },
    resetForm() {
      this.pdfText = 'Avans'
      this.loading = false
      this.paidAmount = 0
      this.accountId = null
      this.selectedVAT = 18
      this.invoiceRemark = null
      this.filiale = { storeId: null, storeName: 'No filiale', storeGLN: null }
      this.isButtonSubmited = false
      this.createHouseItemRequestDtos = []
      this.orderNumber = '';
      this.client = false;
      this.searchClients = null
      this.clientId = '00000000-0000-0000-0000-000000000000'
      this.resetCustomerData();
      this.isButtonSubmited = false;
      this.description = '';
      this.clearCustomMeasurements()
      this.from = null
      this.to = null
      this.durationTimeHour = 0
      this.durationTimeMinutes = 0
      this.userIds = []
    },
    resetCustomerData() {
      this.staticForm.ordererDto.salutation = null;
      this.staticForm.ordererDto.firstName = '';
      this.staticForm.ordererDto.lastName = '';
      this.staticForm.ordererDto.email = '';
      this.staticForm.ordererDto.gender = null;
      this.staticForm.ordererDto.telephoneNumber = '';

      this.staticForm.billingAddressDto.street = '';
      this.staticForm.billingAddressDto.houseNumber = '';
      this.staticForm.billingAddressDto.doorNumber = '';
      this.staticForm.billingAddressDto.postalCode = '';
      this.staticForm.billingAddressDto.city = '';
      this.staticForm.billingAddressDto.country = '';

      this.staticForm.shippingAddressDto.street = '';
      this.staticForm.shippingAddressDto.houseNumber = '';
      this.staticForm.shippingAddressDto.doorNumber = '';
      this.staticForm.shippingAddressDto.postalCode = '';
      this.staticForm.shippingAddressDto.city = '';
      this.staticForm.shippingAddressDto.country = '';

      this.pickUpInStore = false;
      this.isPhoneNumberValid = null;
      this.searchClients = null
      this.clientId = '00000000-0000-0000-0000-000000000000'
    },

  },
};
</script>

<style lang="scss" scoped>

.modal-header{
  font-size: 25px !important;
}

.fixed-height-modal[data-v-094d39fb] {
    height: 100%;
    overflow-y: auto;
    padding-right: 1rem;
}
textarea.form-control {
    min-height: calc(1.5em + 0.75rem + 2px);
    width: 1090px;
}
fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
    width: 49%;
}
.price-container {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}

.hello{
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 1%
}
.price-text {
  margin-left: 0px;
  font-size: 18px;
  // font-weight: bold;
  color: black;
  border-radius: 10px;
}
.search1 {
    padding: 0px;
  }
.black {
  position: relative;
}
.black input {
  height: 38px;
}
.dropdrop::-webkit-scrollbar {
display: none;

}
.dropdrop {
display: inline-block;
overflow: auto;
position: absolute;
background: white;
width: 227px;
z-index: 2;
box-shadow: none;
}
.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}
.search-item:last-child {
  border-bottom: none;
}
.search-item:hover {
  background: #82868c;
  color: white;
}
.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}
.is-active {
  background-color: #dedede;
}
form {
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}


.headline {
  padding: 10px 10px;
  background-color: white;
  color: black;
  font-weight: bold;
  border-radius: 8px;
}

.custom-modal__wrapper {
  display: flex;
  justify-content: space-between;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 10px 0px;

  >div {
    flex: 1;
    margin: 0px 15px;
  }
}

.flex-form {
  display: flex;
  flex-direction: column;
}

.fixed-height-modal {
  height: 100%;
  overflow-y: auto;
  padding-right: 1rem;
}


.inside-actions {
  margin-left: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  box-shadow: none;
  padding: 2px 4px;
  border-radius: 7px;
}

.inside-actions:hover {
  background-color: #242F6E;
  color: #fff;
}

.f {
  border-color: red !important;
}


.btn-con {
  display: flex;

  button {
    border: none;
    background: #FF274F;
    color: $digit-white;
    border-radius: 0.25rem;
    padding: 3px 12px;
  }
}


@media only screen and (max-width: 1200px) {
  textarea.form-control[data-v-094d39fb] {
    min-height: calc(1.5em + 0.75rem + 2px);
    width: 745px;
  }
  .existingClient{
    width: 65% !important;
  }

  .btn-con {
    display: flex;

    button {
      border: none;
      background-color: #6c757d;
      ;
      color: $digit-white;
      border-radius: 0.25rem;
      padding: 3px 12px;
    }
  }


input[type="radio"]:checked:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -3px;
  left: -1px;
  position: relative;
  background-color: $base-color ;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}
}

</style>
